/**
 * Sign-in surface. A branded screen with a single sign-in action that triggers
 * MSAL's loginRedirect through the resolver seam (Entra now; Auth0 at merge).
 * Mirrors experts-web's SignInPage. Uses the shared @andavo/web-ui Button +
 * AndavoLogo so the brand is native.
 */
import { AndavoLogo, Button } from '@andavo/web-ui';
import { login } from '@/auth/msal';

export function SignInPage() {
  return (
    <div className="flex h-full w-full items-center justify-center bg-surface-background p-6">
      <div className="flex w-full max-w-sm flex-col items-center gap-6 rounded-lg border border-border-card bg-surface-midground p-8 shadow-elevation-100">
        <AndavoLogo />
        <div className="flex flex-col items-center gap-2 text-center">
          <h1 className="font-sans font-semibold text-content-primary text-xl">
            Sign in to AndavoLabs
          </h1>
          <p className="font-inter text-content-secondary text-sm">
            Use your Christopherson Andavo account to access chat, customer
            management, and expense.
          </p>
        </div>
        <Button
          className="w-full"
          data-testid="signin-button"
          onClick={() => {
            void login();
          }}
          variant="primary"
        >
          Sign in
        </Button>
        {/*
          New-user path. A plain <a> (not a router <Link>) on purpose: the
          access-request form is served by the experts BACKEND at
          /api/access-request (GET renders the branded form, POST submits it).
          Through the edge, only /api/* routes to the backend — a bare
          /access-request would hit the SPA catch-all and 404 into the router.
          cbtravel.com submissions are AUTO-APPROVED (instant Graph B2B invite,
          no human review, no cbtravel-tenant config); other domains route to
          admin review. This link regressed when experts-web's SignInPage was
          ported into the unified app — the port dropped it (2026-06-23).
        */}
        <a
          className="font-inter text-content-secondary text-sm underline-offset-2 hover:underline"
          data-testid="request-access-link"
          href="/api/access-request"
        >
          New here? Request access
        </a>
      </div>
    </div>
  );
}

export default SignInPage;
